<template>
    <button 
        class="progress-button" 
        :class="{ 'is-loading': showProgress }"
        @click="$emit('click')"
    >
        <span v-if="!showProgress" style="font-weight:bold;" :style="{fontSize: customFontSize}">{{ buttonText }}</span>
        <div v-else class="progress-circle">
            <div class="progress-rotate">
                <svg class="progress-ring" :class="[isIOS ? 'rotate_ani_ios' : 'rotate_ani']" width="24" height="24">
                <circle
                    class="progress-ring-circle"
                    :class="[isIOS ? 'animation_ios' : 'animation']"
                    stroke="white"
                    stroke-width="2"
                    fill="transparent"
                    r="10"
                    cx="12"
                    cy="12"    
                />
            </svg>
            </div>

        </div>
    </button>
</template>

<script>
export default {
    name: 'ProgressButton',
    props: {
        buttonText: {
            type: String,
            required: true
        },
        showProgress: {
            type: Boolean,
            default: false
        },
        customFontSize: {
            type: String,
            default: '14px'
        }
    },
    emits: ['click'],
    computed : {
        isIOS(){
            return (/iPhone|iPad|iPod/i.test(navigator.userAgent))
        }
    },
    created(){

    }
}
</script>

<style scoped>
.progress-button {
    width: 100%;
    padding: 12px;
    background-color: var(--color-main);
    color: white;
    font-size: 16px;
    margin-top: 20px;
    position: relative;
    min-height: 44px;;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 12px;
    cursor: pointer;
}

.progress-button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
}

.progress-circle {
    display: flex;
    align-items: center;
    justify-content: center;
}

.progress-ring {
    transform: rotate(0deg);

}

.progress-rotate{
    animation: rotate 2s linear infinite;
    font-size:0px;
}


.progress-ring.rotate_ani{}

.progress-ring.rotate_ani_ios{
    animation: rotate_ios 2s linear infinite;
}

.progress-ring-circle {
    stroke-dasharray: 62.83;
}

.progress-ring-circle.animation{
    stroke-dashoffset: 62.83;
    animation : dash 2.0s linear infinite
}

.progress-ring-circle.animation_ios{
    stroke-dashoffset: 62.83;
    animation : dash_ios 2.0s linear infinite
}   

@keyframes rotate {
    0% {
        transform: rotate(-90deg);
    }
    50% {
        transform: rotate(90deg);
    }
    100% {
        transform: rotate(270deg);
    }
}

@keyframes rotate_ios {
    0% {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}


@keyframes dash {
    0% {
        stroke-dashoffset: 62.83;
    }
    50% {
        stroke-dashoffset: 0;
    }
    100% {
        stroke-dashoffset: -62.83;
    }
}

@keyframes dash_ios {
    0% {
        stroke-dashoffset: 62.83;
    }
    50% {
        stroke-dashoffset: 0;
    }
    100% {
        stroke-dashoffset: 62.83;

    }
}
</style> 